import { useQuery } from '@apollo/client/react'
import { gql } from '@apollo/client'

const GET_AGENT_DECISIONS = gql`
  query GetAgentDecisions($clientId: ID!, $limit: Int) {
    agentDecisions(clientId: $clientId, limit: $limit) {
      id
      clientId
      agentReasoning
      validatedActions
      createdAt
      executed
    }
  }
`

export interface AgentDecision {
  id: string
  clientId: string
  agentReasoning: string
  validatedActions: Array<{ type: string; params: Record<string, unknown> }>
  createdAt: string
  executed: boolean
}

export function useAgentDecisions(clientId: string, limit = 5) {
  const { data, loading, error } = useQuery<{
    agentDecisions: AgentDecision[]
  }>(GET_AGENT_DECISIONS, { variables: { clientId, limit } })

  return {
    decisions: data?.agentDecisions ?? [],
    loading,
    error,
  }
}
